import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import * as tribunalAPI from '@debbie/cortex/dist/api/tribunal.js';
import { DKTribunalJobType } from '@debbie/common/dist/tribunal/jobs/countries/denmark.js';
import Button from '../../../Button.js';
import { tribunalJobsEntity } from '@debbie/cortex/dist/tribunal/index.js';
import keys from '@debbie/common/dist/cache/keys.js';
import q from '@debbie/cortex/dist/query.js';
import DateInput from '../../../DateInput.js';
const Policepresentation = (props) => {
    const lang = useSelector((s) => s.lang);
    const [loading, setLoading] = useState(false);
    const [date, setDate] = useState(moment());
    const registerPolicePresentation = async () => {
        setLoading(true);
        try {
            await tribunalAPI.createTribunalJob({
                type: DKTribunalJobType.RegisterPolicePresentation,
                tribunalCaseId: props.tribunalCase.id,
                data: {
                    date: date.format(),
                },
                caseId: props.tribunalCase.caseId,
                reference: `${props.tribunalCase.reference || 'FS'}`.trim(),
            });
            props.onSubmit();
        }
        catch (err) {
            console.error(err);
        }
        setLoading(false);
        q.invalidate(keys.write.create(tribunalJobsEntity));
    };
    return (React.createElement("div", null,
        React.createElement("h4", null, "Politifremstilling"),
        React.createElement("div", { style: { display: 'inline-flex' } },
            React.createElement("p", null, lang.tribunal.debtorSentToPolicePresentation),
            React.createElement(DateInput, { placeholder: "Dato", value: date, allowNull: false, onChange: (date) => setDate(date), style: { marginLeft: '10px' } })),
        React.createElement(Button, { onClick: registerPolicePresentation, loading: loading, block: true }, lang.tribunal.registerPolicePresentation)));
};
export default Policepresentation;
//# sourceMappingURL=Policepresentation.js.map